export default __webpack_public_path__ + "static/media/amertrad11.57bbf1b6.png";